import axios from "axios";
import { ref } from "vue";
import type { Ref } from "vue";

export const useApiClient = () => {
  const client = axios.create({
    baseURL: "/api",
    headers: {
      "content-type": "application/json",
      [window.csrfTokenName]: window.csrfToken,
      Authorization: `Bearer ${window.gqlToken}`,
    },
  });

  return client;
};

export const useApi = (factory: Function, handleResponse: Function) => {
  const client = useApiClient();

  const isLoading = ref(false);
  const result: Ref<any> = ref(null);
  const error: Ref<string | null> = ref(null);
  const execute = async (...args: any) => {
    const request = factory(...args);

    isLoading.value = true;
    error.value = null;
    try {
      const response = await client.post("", request);
      const valueResponse = await handleResponse(response);

      result.value = valueResponse;
      return valueResponse;
    } catch (e) {
      let message = "Unknown error";
      if (e instanceof Error) {
        message = e.message;
      }
      error.value = message;
      result.value = null;
    } finally {
      isLoading.value = false;
    }
  };

  return {
    isLoading,
    result,
    error,
    execute,
  };
};
